import { writable } from "svelte/store"

/**
 * @type {import("svelte/store").Writable<Array<import("../Script/document").bulkDocument>>}
 */

const bulkJson = writable([])

export default bulkJson
